/**
 * Serializes query params with arrays as repeated keys
 * (e.g. `?key=a&key=b` instead of Axios default `?key[]=a&key[]=b`).
 * Skips undefined/null values.
 */
export const serializeArrayParams = (
	params: Record<string, unknown>
): string => {
	const searchParams = new URLSearchParams();
	Object.entries(params).forEach(([key, value]) => {
		if (Array.isArray(value)) {
			value.forEach((item) => {
				if (item === undefined || item === null) return;
				searchParams.append(key, String(item));
			});
		} else if (value !== undefined && value !== null) {
			searchParams.append(key, String(value));
		}
	});
	return searchParams.toString();
};
